import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import FloatingBubbles from '../components/FloatingBubbles';
import axios from 'axios';

export default function ResetPassword() {
  const { API } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Les mots de passe ne correspondent pas.'); return; }
    if (password.length < 6) { setError('Le mot de passe doit faire au moins 6 caractères.'); return; }
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.detail || 'Lien invalide ou expiré.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) return (
    <div style={{ textAlign: 'center', padding: '80px', color: 'var(--muted)' }}>
      Lien invalide. <Link to="/forgot-password" style={{ color: 'var(--blue)' }}>Demander un nouveau lien</Link>
    </div>
  );

  return (
    <>
      <FloatingBubbles />
      <div style={{ position: 'relative', zIndex: 1, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
        <div style={{ width: '100%', maxWidth: '420px', background: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(12px)', borderRadius: '20px', padding: '40px 32px', boxShadow: '0 8px 32px rgba(43,108,176,0.12)', border: '1px solid rgba(190,227,248,0.4)' }}>

          {success ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
              <h2 style={{ fontSize: '22px', fontWeight: 800, color: 'var(--dark)', marginBottom: '12px' }}>Mot de passe modifié !</h2>
              <p style={{ fontSize: '14px', color: 'var(--text)', lineHeight: 1.7 }}>Tu vas être redirigé vers la page de connexion dans 3 secondes...</p>
              <Link to="/login" style={{ color: 'var(--blue)', fontWeight: 600, fontSize: '14px', display: 'block', marginTop: '16px' }}>Se connecter →</Link>
            </div>
          ) : (
            <>
              <div style={{ textAlign: 'center', marginBottom: '28px' }}>
                <div style={{ fontSize: '40px', marginBottom: '12px' }}>🔐</div>
                <h2 style={{ fontSize: '24px', fontWeight: 800, color: 'var(--dark)', marginBottom: '8px' }}>Nouveau mot de passe</h2>
                <p style={{ fontSize: '14px', color: 'var(--text)', lineHeight: 1.6 }}>Choisis un nouveau mot de passe pour ton compte.</p>
              </div>

              {error && <div style={{ background: '#FFF5F5', border: '1px solid #FED7D7', borderRadius: '10px', padding: '12px 16px', fontSize: '13px', color: 'var(--red)', marginBottom: '16px' }}>{error}</div>}

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                <div>
                  <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: '6px' }}>Nouveau mot de passe</label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="6 caractères minimum" required
                    style={{ width: '100%', padding: '12px 16px', border: '1.5px solid var(--blue-border)', borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}
                    onFocus={e => e.target.style.borderColor = 'var(--blue)'} onBlur={e => e.target.style.borderColor = 'var(--blue-border)'}
                  />
                </div>
                <div>
                  <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: '6px' }}>Confirmer le mot de passe</label>
                  <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Répète le mot de passe" required
                    style={{ width: '100%', padding: '12px 16px', border: `1.5px solid ${confirm && confirm !== password ? '#FC8181' : 'var(--blue-border)'}`, borderRadius: '10px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}
                    onFocus={e => e.target.style.borderColor = confirm !== password ? '#FC8181' : 'var(--blue)'} onBlur={e => e.target.style.borderColor = confirm && confirm !== password ? '#FC8181' : 'var(--blue-border)'}
                  />
                  {confirm && confirm !== password && <p style={{ fontSize: '12px', color: 'var(--red)', marginTop: '4px' }}>Les mots de passe ne correspondent pas</p>}
                </div>
                <button type="submit" disabled={loading || !password || !confirm} style={{ background: 'var(--blue)', color: '#fff', border: 'none', padding: '13px', borderRadius: '12px', fontSize: '14px', fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 12px rgba(43,108,176,0.3)', opacity: loading ? 0.7 : 1 }}>
                  {loading ? 'Modification...' : 'Modifier le mot de passe →'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </>
  );
}
